import { useState } from "react";
import { useReveal } from "@/hooks/useReveal";

const FAQS = [
  {
    q: "How is this different from the brown sugar already on the shelf?",
    a: "Most brown sugar is refined white sugar with molasses added back after the fact. Ours is never separated, and it carries a valid organic certification rather than a claim on the pack.",
  },
  {
    q: "Can we sell it under our own brand instead?",
    a: "Yes. That is a separate conversation and a different set of terms — tell us in the form and we will send the private label proposal rather than this one.",
  },
  {
    q: "What happens if the category does not move?",
    a: "We would rather find that out in a trial period than lock you into an exclusivity you regret. That is why step two exists.",
  },
  {
    q: "Will you also sell to retailers in my territory directly?",
    a: "No. Once a territory and channel are agreed in writing, enquiries from that territory come to you.",
  },
  {
    q: "Can you support a national listing later?",
    a: "Our realistic export commitment is one to two 40 ft containers per quarter. We will tell you before you pitch a chain whether we can supply what winning it would require.",
  },
  {
    q: "Who pays for the point-of-sale material?",
    a: "We produce and ship it with the order at our cost, within an agreed quantity. Bespoke campaigns beyond that are shared.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const ref = useReveal<HTMLDivElement>();

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal text-center">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Questions we are always asked
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className="border border-cream-dark/60 rounded-lg overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 text-left"
                >
                  <span className="text-ink font-serif text-base md:text-lg font-semibold">
                    {item.q}
                  </span>
                  <i
                    className={`text-brown text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5">
                    <p className="text-ink/70 text-[17px] leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}